import { AxiosError } from 'axios';
import { FormEventHandler, useState } from 'react';
import { Form, Toast, ToastContainer } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import SubmitButton from '../components/Buttons/SubmitButton';
import { DEFAULT_ERROR_MESSAGE } from '../consts';
import { isValidEmail } from '../helpers/validation';
import api from '../utils/api';

const SignUpForm = () => {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('admin');
  const [fullName, setFullName] = useState('');
  const [nickName, setNickName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const createAccountHandler: FormEventHandler = async e => {
    e.preventDefault();
    setLoading(true);

    try {
      await api('post', '/auth/register', {
        email,
        role,
        fullName,
        nickName,
        phoneNumber,
        createdBy: '66056a0b8cddbeac52b7221f'
      });

      setLoading(false);
      navigate('/login');
    } catch (error) {
      setLoading(false);
      error instanceof AxiosError ? setError(error.response?.data.message) : setError(DEFAULT_ERROR_MESSAGE);
      setTimeout(() => {
        setError('');
      }, 3000);
    }
  };

  return (
    <>
      <h1 className="display-4 text-center mb-3">Sign up</h1>
      <p className="text-muted text-center mb-5">Warehouse management application.</p>
      <form onSubmit={createAccountHandler}>
        <div className="form-group">
          <Form.Label htmlFor="email">Email Address</Form.Label>
          <Form.Control
            type="email"
            id="email"
            placeholder="name@address.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            isValid={isValidEmail(email)}
          />
        </div>
        <div className="form-group">
          <Form.Label htmlFor="name">Full Name</Form.Label>
          <Form.Control
            type="text"
            id="name"
            placeholder="John Doe"
            value={fullName}
            onChange={e => setFullName(e.target.value)}
            isValid={fullName.trim() !== ''}
          />
        </div>
        <div className="form-group">
          <Form.Label htmlFor="nickname">Nickname</Form.Label>
          <Form.Control
            type="text"
            id="nickname"
            placeholder="johnny"
            value={nickName}
            onChange={e => setNickName(e.target.value)}
            isValid={nickName.trim() !== ''}
          />
        </div>
        <div className="form-group">
          <Form.Label htmlFor="phone">Phone Number</Form.Label>
          <Form.Control
            type="tel"
            id="phone"
            placeholder="08012345678"
            value={phoneNumber}
            onChange={e => setPhoneNumber(e.target.value)}
            isValid={phoneNumber.trim() !== ''}
          />
        </div>
        <div className="form-group">
          <Form.Label htmlFor="role">Role</Form.Label>
          <Form.Select id="role" value={role} onChange={e => setRole(e.target.value)} isValid>
            <option value="admin">Admin</option>
            <option value="finance">Finance</option>
            <option value="supervisor">Supervisor</option>
            <option value="stockKeeper">Stock Keeper</option>
          </Form.Select>
        </div>

        <SubmitButton
          buttonText="Sign up"
          loading={loading}
          disabled={!isValidEmail(email) || !fullName.trim() || !nickName.trim() || !phoneNumber.trim()}
        ></SubmitButton>

        {error && (
          <ToastContainer position="bottom-center" className="p-3">
            <Toast bg="danger">
              <Toast.Body className="text-white">{error}</Toast.Body>
            </Toast>
          </ToastContainer>
        )}
      </form>
    </>
  );
};

export default SignUpForm;
